import { ListItem, Typography, styled } from '@mui/material'
import { t } from '$i18n'
import { PosInBlock } from '../../react-hooks'
import { getPadding } from '../message-wrapper/message-wrapper'

interface StyledListItemProps {
  posInBlock: PosInBlock
}

const StyledListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== 'posInBlock',
})<StyledListItemProps>`
  width: 100%;
  padding: ${({ posInBlock }) => getPadding(posInBlock, true, false)};

  margin: 0;
  &:first-of-type {
    margin-top: 6px;
  }
  &:last-child {
    margin-bottom: 6px;
  }
`

const Container = styled('div')`
  display: flex;
  align-items: center;

  width: fit-content;
  margin: 0 auto;
  padding: 3px 30px;
  border-radius: 21px;
  background-color: #0000004d;
  text-align: center;
  overflow: hidden;
  min-height: 30px;
`

interface Props {
  posInBlock: PosInBlock
}
export const JoinedChannelEvent = ({ posInBlock }: Props) => {
  return (
    <StyledListItem posInBlock={posInBlock}>
      <Container>
        <Typography color="white" variant="caption1" sx={{ flexShrink: 0 }}>
          {t('chat.event.youJoinedChannel')}
        </Typography>
      </Container>
    </StyledListItem>
  )
}
